"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = {
    urlBase: null,
    siteId: 1,
};
exports.TRACK_TYPES = {
    TRACK_EVENT: 'trackEvent',
    TRACK_LINK: 'trackLink',
    TRACK_SEARCH: 'trackSiteSearch',
    TRACK_VIEW: 'trackPageView',
};
//# sourceMappingURL=constants.js.map